import { combineReducers } from 'redux-immutable'
import teamCalendarReducer from './team-calendar-reducer'

export default combineReducers({
  teamCalendar: teamCalendarReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/team-calendar/index.js